import React, { useMemo } from 'react';
import styles from './RequestTable.module.css';
import { fmtSize, fmtTime, timeClass, statusColor, isInScope } from '../utils/harUtils';

export default function RequestTable({ requests, target, onSelect }) {
  const rows = useMemo(() => requests, [requests]);

  if (rows.length === 0) {
    return (
      <div className={styles.empty}>
        <div className={styles.emptyIcon}>🔎</div>
        <div className={styles.emptyTitle}>No requests match</div>
        <p>Try adjusting your search or filters</p>
      </div>
    );
  }

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thStatus}>Status</th>
            <th className={styles.thMethod}>Method</th>
            <th className={styles.thType}>Type</th>
            <th className={styles.thUrl}>Full URL</th>
            <th className={styles.thSize}>Size</th>
            <th className={styles.thTime}>Time</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((req) => {
            const sc = statusColor(req.status);
            const isError = req.status >= 400 || req.status === 0;
            const inScope = target ? isInScope(req.domain, target) : null;

            // Build display URL: scheme+domain colored, path dimmed
            let origin = '';
            let pathPart = req.url;
            try {
              const u = new URL(req.url);
              origin = u.origin;
              pathPart = u.pathname + u.search + u.hash;
            } catch (_) {}

            // Domain color: green=inscope, amber=external, cyan=no target set
            const domainColor = target
              ? (inScope ? 'var(--accent3)' : 'var(--warn)')
              : 'var(--accent)';

            return (
              <tr
                key={req.id}
                className={styles.row}
                onClick={() => onSelect(req)}
                title={req.url}
              >
                <td className={styles.tdStatus}>
                  <span className={`${styles.dot} ${styles['dot_' + sc]}`} />
                  <span style={{ color: isError ? 'var(--red)' : 'var(--text)', fontWeight: 600 }}>
                    {req.status || '—'}
                  </span>
                </td>

                <td className={styles.tdMethod}>
                  <span className={`${styles.methodBadge} ${styles['method_' + req.method]}`}>
                    {req.method}
                  </span>
                </td>

                <td className={styles.tdType}>
                  <span className={styles.typeLabel}>{req.typeCategory}</span>
                </td>

                <td className={styles.tdUrl}>
                  <div className={styles.urlCell} title={req.url}>
                    {origin ? (
                      <>
                        <span style={{ color: domainColor, fontWeight: 600 }}>{origin}</span>
                        <span style={{ color: 'var(--text2)' }}>{pathPart}</span>
                      </>
                    ) : (
                      <span style={{ color: 'var(--text)' }}>{req.url}</span>
                    )}
                  </div>
                </td>

                <td className={styles.tdSize}>
                  <span className={styles.meta}>{fmtSize(req.size)}</span>
                </td>

                <td className={styles.tdTime}>
                  <span className={`${styles.meta} ${styles['time_' + timeClass(req.time)]}`}>
                    {fmtTime(req.time)}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
